// extracted by mini-css-extract-plugin
export default {"head":"head--2d90da76","menu":"menu--78e485c4","title":"title--41373e3a","navs":"navs--c9283e9a","search":"search--98200a19"};